<template>
    <div class="content">
        <div class="tabs-container">
            <div class="content-view" ref="scrollbar">
                <div class="sticky-tabs">
                    <div class="project-title">搜索关键词：{{ projectName }}</div>
                    <el-tabs v-model="activeTab" ref="tabs" :key="isMounted ? 'mounted' : ''">
                        <el-tab-pane label="报价单" name="quotationManagement">
                            <quotationManagement :showQuery="false" :projectName="projectName" />
                        </el-tab-pane>
                        <el-tab-pane label="合同管理" name="contractmanagementAll">
                            <ContractManagementAll :showQuery="false" :projectName="projectName" />
                        </el-tab-pane>
                        <el-tab-pane label="订单" name="orderDetails">
                            <OrderDetails :showQuery="false" :projectName="projectName" />
                        </el-tab-pane>
                        <el-tab-pane label="商城订单" name="mallorder">
                            <MallOrder :showQuery="false" :projectName="projectName" />
                        </el-tab-pane>
                        <!-- <el-tab-pane label="分款记录" name="onlinePayment">
                            <SubdivisionRecordmanagement :showQuery="false" :projectName="projectName" />
                        </el-tab-pane> -->
                        <el-tab-pane label="在线调款" name="onlinePayment">
                            <OnlinePayment :showQuery="false" :projectName="projectName" />
                        </el-tab-pane>
                        <el-tab-pane label="发货申请" name="paymentVoucher">
                            <DeliveryRequisition :showQuery="false" :projectName="projectName" />
                        </el-tab-pane>

                        <el-tab-pane label="业绩划分" name="performanceDivision">
                            <PerformanceDivision :showQuery="false" :projectName="projectName" />
                        </el-tab-pane>
                        <el-tab-pane label="退货管理" name="contractreturnManagement">
                            <ContractReturnManagement :showQuery="false" :projectName="projectName" />
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import quotationManagement from '@/views/quotationManagement/index';
import MallOrder from '@/views/orderManagement/mallorder/index.vue';
import OrderDetails from '@/views/orderManagement/index.vue';
// import SubdivisionRecordmanagement from '@/views/orderManagement/subdivisionRecordmanagement/index.vue';
import OnlinePayment from '@/views/orderManagement/onlinePayment/index.vue';
import DeliveryRequisition from '@/views/deliveryRequisition/index.vue';
import ContractManagementAll from '@/views/contractManagement/index.vue';
import PerformanceDivision from '@/views/performanceDivision/index.vue';
import ContractReturnManagement from '@/views/contractreturnManagement/index.vue';

export default {
    name: 'projectTabs',
    components: {
        quotationManagement,
        MallOrder,
        OrderDetails,
        // SubdivisionRecordmanagement,
        OnlinePayment,
        DeliveryRequisition,
        ContractManagementAll,
        PerformanceDivision,
        ContractReturnManagement
    },
    data() {
        return {
            activeTab: 'quotationManagement',
            projectName: this.$route.query.projectName || '',
            isMounted: false
        };
    },
    mounted() {
        this.isMounted = true;
    }
};
</script>

<style lang="scss" scoped>
.project-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
}

.tabs-container {
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
}

.sticky-tabs {
    position: sticky;
    top: -20px;
    z-index: 10;
    background: #fff;
}

.tabs-content {
    flex: 1;
    overflow: hidden;

    height: 400px;
}
</style>
<style scoped lang="scss">
.action {
    /deep/.custom-label {
        // background: #f5f7fa !important;
        max-width: 150px !important;
        min-width: 120px !important;
        line-height: 30px;
        display: inline-block;
        text-align: right !important;
        color: #000000;
        font-weight: bold;
    }

    /deep/ .el-descriptions-item__content {
        display: flex;
        align-items: center;
        color: #000000;
        font-size: 14px;
    }
}

/deep/.form-title {
    line-height: 40px;
    background-color: #eeeeee;
    padding-left: 15px;
}

/deep/.el-table {
    color: #000000;
}

/deep/.el-table thead {
    color: #000000;
}

/deep/ .el-descriptions__body {
    color: #000000;
}

/deep/.el-descriptions-item__label:not(.is-bordered-label) {
    color: #000000;
    font-weight: bold;
    font-size: 14px;
}

/deep/.el-form-item__label {
    color: #000000;
    font-weight: bold !important;
}

/deep/.el-form .el-form-item .el-form-item__label {
    font-weight: bold !important;
}

/deep/.info .info-item .label {
    font-weight: bold;
}

/deep/.el-radio {
    color: #000000;
}

/deep/ .el-step__title {
    font-size: 14px !important;
}

/deep/ .el-step__title.is-process {
    font-size: 14px !important;
}

/deep/ .el-tabs__nav-wrap::after {
    height: 1px !important;
}

.nav-title {
    padding: 40px 20px 20px 20px;
}

.steps {
    transform: scale(0.85);
}

.content-view {
    background: #fff;
    padding: 20px;
    margin-bottom: 50px;
    overflow-y: hidden;
}

::v-deep .content-view .custom-label {
    text-align: right !important;
    width: 120px;
    color: #333;
    // background-color: #f5f7fa !important;
}

::v-deep .content-view .el-collapse-item__header {
    font-size: 15px;
    color: #222;
    font-weight: 500 !important;
}

.content-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 0px !important;
}

.customers-info {
    margin-top: 20px;
}

.his-customers-list {
    margin-top: 20px;
}

.his-customers {
    line-height: 30px;
}

.signature-tips {
    border: 1px dashed #90dd90;
    font-style: normal;
    font-size: 12px;
    color: #008000;
    line-height: 20px;
    display: inline-block;
    vertical-align: middle;
    margin-left: 10px;
    background-color: #95ffa0;
    padding: 0 4px;
    border-radius: 0 10px 0 10px;
}

.action-title {
    padding-bottom: 15px;
    border-bottom: 1px solid #e4e7ed;
    margin-bottom: 15px;
}

.labelClassNameBox {
    /deep/.labelClassName {
        width: 150px;
        text-align: right;
    }

    .rows {
        width: 350px;
    }
}

.content_Pipeline {
    display: flex;
    width: 500px;
    flex-wrap: wrap;
    margin-top: 10px;

    div {
        margin-right: 10px;
    }

    .content_title {
        font-weight: 700;
        letter-spacing: 2rpx;
        width: 600rpx;
    }
}

.content {
    display: flex;
    flex-direction: column;
}

.content-view {
    display: flex;
    flex-direction: column;
}

.tabs-container {
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
}

.sticky-tabs {
    position: sticky;
    top: -20px;
    z-index: 10;
    background: #fff;
}

.sticky-form {
    padding: 16px;
    background: #fff;
    border-bottom: 1px solid #e4e7ed;
}

.scroll-content {
    flex: 1;
    overflow-y: hidden;
    padding: 20px 0;
}

/deep/.storage_list {
    display: block;
}
</style>
